import { useTranslation } from 'react-i18next';
import heroImg from '../static/images/home_photo.jpg';

const Hero = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className="w-full lg:w-[1000px] h-[400px] md:h-[900px] rounded-xl mt-16 flex justify-center items-center relative bg-cover bg-center" style={{ backgroundImage: `url(${heroImg})` }}>
            <div className='absolute bottom-[260px] md:bottom-[600px] right-0 top-0 left-0 p-4 bg-gradient-to-b from-slate-900 to-transparent flex flex-col justif-start md:pt-16 items-center rounded-xl'> {/* bg-gradient-to-t from-slate-900 to-transparent */}
                <div className="flex flex-col md:flex-row items-center mb-4">
                    <div className='text-white text-2xl mt-4 font-bold text-center'>{t('Homepage.Hero.which')}</div>
                    <div className="flex items-center gap-2">
                        <div className='font-signature text-[#fbd100] text-3xl md:text-7xl flex justify-center w-full md:w-fit md:ml-4 md:pr-2'>{t('Homepage.Hero.adventure')}</div>
                        <div className='text-white md:text-4xl md:mt-4 font-bold'>?</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero;